var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5C3.73478 0.5 3.48043 0.605357 3.29289 0.792893C3.10536 0.98043 3 1.23478 3 1.5V3.078C3 4.40408 3.52678 5.67585 4.46447 6.61353C5.40215 7.55122 6.67392 8.078 8 8.078C9.32608 8.078 10.5979 7.55122 11.5355 6.61353C12.4732 5.67585 13 4.40408 13 3.078V1.5C13 1.23478 12.8946 0.98043 12.7071 0.792893C12.5196 0.605357 12.2652 0.5 12 0.5H4Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.4999C3.73478 15.4999 3.48043 15.3945 3.29289 15.207C3.10536 15.0194 3 14.7651 3 14.4999V12.9219C3 11.5958 3.52678 10.324 4.46447 9.38634C5.40215 8.44866 6.67392 7.92188 8 7.92188C9.32608 7.92188 10.5979 8.44866 11.5355 9.38634C12.4732 10.324 13 11.5958 13 12.9219V14.4999C13 14.7651 12.8946 15.0194 12.7071 15.207C12.5196 15.3945 12.2652 15.4999 12 15.4999H4Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65137 5.5H12.3487",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3654 15.4313C11.5094 13.634 9.87543 12 8.0001 12C6.12477 12 4.49077 13.634 3.63477 15.4313",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.b0532e78.svg";
export { ForwardRef as ReactComponent };